// src/config/navConfig.js
import {
  HomeIcon,
  WifiIcon,
  Cog6ToothIcon,
  MapIcon,
  ChartBarIcon,
  UserGroupIcon,
  TagIcon,
  BriefcaseIcon,
  PencilSquareIcon,
  ClipboardDocumentListIcon,
  CreditCardIcon,
  BellIcon,
} from '@heroicons/react/24/outline';

/**
 * 閫氱敤瀛楁璇存槑
 * 鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€
 * title      鑿滃崟鏍囬
 * icon       鍥炬爣缁勪欢锛堝彲閫夛級
 * children   瀛愯彍鍗曪紙閫掑綊鍚岀粨鏋勶級
 */
// TODO 鏆傛椂鍒犻櫎浜唒erm瀛楁鐨勪娇鐢ㄩ€昏緫锛屽悗缁ˉ鍏呮潈闄愮鐞嗗姛鑳芥椂鍐嶅姞鍥炴潵
const NAV_CONFIG = {
  /** Venue 角色 ───────────────────────── */
  venue: [
    { title: 'Dashboard', path: '/' },
    {
      title: 'Home',
      icon: HomeIcon,
      children: [
        { title: 'Layout', path: '/home/layout' },
        { title: 'Quick Links', path: '/home/quick-links' },
      ],
    },
    {
      title: 'Services',
      icon: WifiIcon,
      children: [
        { title: 'Layout', path: '/services/layout' },
        { title: 'Content', path: '/services/content' },
      ],
    },
    {
      title: 'Settings',
      icon: Cog6ToothIcon,
      children: [
        { title: 'Brand Style', path: '/settings/brand-style' },
        { title: 'Theme', path: '/settings/theme' },
        { title: 'Display Collateral', path: '/settings/display-collateral' },
        { title: 'Contact', path: '/settings/contact' },
      ],
    },
    { title: 'Map', icon: MapIcon, path: '/map' },
    { title: 'Notifications', icon: BellIcon, path: '/notifications' },
    { title: 'Analytics', icon: ChartBarIcon, path: '/analytics' },
    {
      title: 'Account',
      icon: UserGroupIcon,
      children: [
        // { title: 'Add Users', path: '/user/add-user', perm: 'user:add' },
        { title: 'Add Users', path: '/user/add-user' },

      ],
    },
    {
      title: 'Billing',
      icon: CreditCardIcon,
      path: '/billing'
    },
  ],

  /** Advertiser 角色 ───────────────────── */
  adv: [
    { title: 'Dashboard', path: '/' },
    { title: 'Ad settings', icon: TagIcon, path: '/ads-settings' },
    { title: 'Ad Detail', icon: BriefcaseIcon, path: '/ads-content' },
    { title: 'Analytics', icon: ChartBarIcon, path: '/analytics' },
    {
      title: 'Account',
      icon: UserGroupIcon,
      path: '/user',
      children: [
        { title: 'Add Users', path: '/user/add-user' },
      ],
    },
  ],

  /** Touchscreen Venue 角色 ───────────── */
  tsVenue: [
    { title: 'Branding & Media', path: 'ts/venue/branding', icon: PencilSquareIcon },
    { title: 'Content Management', path: 'ts/venue/content', icon: ClipboardDocumentListIcon },
    { title: 'Analytics', path: 'ts/venue/analytics', icon: ChartBarIcon },
    { title: 'Imported Events', path: 'ts/venue/imported-events', icon: ClipboardDocumentListIcon },
    {
      title: 'Account',
      icon: UserGroupIcon,
      children: [
        { title: 'Add Users', path: '/user/add-user' },
      ],
    },

  ],
  /** Touchscreen Advertiser 角色 ───────── */
  tsAdv: [
    { title: 'Media Management', path: 'ts/adv/media', icon: PencilSquareIcon },
    { title: 'Content Management', path: 'ts/adv/content', icon: ClipboardDocumentListIcon },

    {
      title: 'Account',
      icon: UserGroupIcon,
      children: [
        { title: 'Add Users', path: '/user/add-user' },
      ],
    },

  ],

  tsContent: [
    { title: 'Content Management', path: 'ts/detail/:roleId', icon: ClipboardDocumentListIcon },
    {
      title: 'Account',
      icon: UserGroupIcon,
      children: [
        { title: 'Add Users', path: '/user/add-user' },
      ],
    },
  ],
};

export default NAV_CONFIG;





